import { Routes, RouterModule } from '@angular/router';
import { EditarCodigoReutilizableComponent } from './editar-codigo-reutilizable.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
  { path: '', component: EditarCodigoReutilizableComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class EditarCodigoReutilizableRouting { }
